import { PostContentType } from "../types/postsFilters";

export const postsContentOptions: PostContentType[] = [
  { label: "Story", value: "story", isSelected: false, relatedTo: ["IG"] },
  {
    label: "Reels / Short video",
    value: "reel",
    isSelected: false,
    relatedTo: ["IG", "FB", "TW", "YT", "LI", "TT", "TH", "SC", "PI", "GMB"],
  },
  {
    label: "Text",
    value: "text",
    isSelected: false,
    relatedTo: ["FB", "TW", "LI", "SC", "TH"],
  },
  {
    label: "Single image",
    value: "image",
    isSelected: false,
    relatedTo: ["IG", "FB", "TW", "PI", "LI", "TT", "TH", "SC"],
  },
  {
    label: "Single video",
    value: "video",
    isSelected: false,
    relatedTo: ["IG", "FB", "TW", "YT", "TT", "TH", "SC", "PI", "LI"],
  },
  {
    label: "Carousel",
    value: "multiMedia",
    isSelected: false,
    relatedTo: ["IG", "FB", "TW", "LI", "TT", "TH", "SC"],
  },
  {
    label: "PDF / Document",
    value: "document",
    isSelected: false,
    relatedTo: ["IG", "FB", "TW", "YT", "LI", "TT", "TH", "SC", "PI", "GMB"],
  },
];

export const postsContentAllOption: PostContentType = {
  label: "All post types",
  value: "*",
  relatedTo: ["IG", "FB", "TW", "YT", "LI", "TT", "TH", "SC", "PI", "GMB"],
};
